import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    // El centerColumn de Page (multiColumns es flex-row) no tiene min-width/flex-basis
    // propio, así que por default un flex item no se encoge por debajo del ancho de su
    // contenido (min-width: auto). Cuando la tabla de conceptos tiene muchas columnas de
    // discriminantes, ese ancho intrínseco empuja todo el layout y el panel izquierdo
    // termina cayendo debajo (flexWrap: wrap-reverse en Page). width: 0 + min-width: 100%
    // corta esa propagación: el contenido deja de "pedir" su ancho intrínseco hacia
    // arriba y en el layout final ocupa el 100% del espacio ya resuelto por el flex padre.
    contentWidthFix: {
      marginLeft: '16px',
      width: '150px',
      minWidth: '100%'
    },
    tableScroll: {
      // Grid item: flex item del Grid container direction="column" de arriba. En el eje
      // cruzado (ancho) también aplica el min-width: auto por default, así que sin esto
      // el item se agranda para abrazar la tabla en vez de clipearla con overflowX.
      // maxWidth corta cualquier crecimiento remanente más allá del ancho disponible,
      // independientemente de flex-basis/stretch (xs={12} ya lo agrega, se repite acá
      // por las dudas de orden de inserción de JSS).
      marginLeft: '16px',
      minWidth: '150px',
      maxWidth: '100%',
      overflowX: 'auto'
    }
  })
